import React from 'react';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import KenButton from '../../../components/KenButton/index';
import moment from 'moment';
//for upcoming adacemic programs
var today = moment();

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  item:{
    marginLeft:20,
    overflow: "hidden",
  }
});

const TableCell = withStyles({
    root: {
      borderBottom: "none"
    }
  })(MuiTableCell);

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}



export default function DenseTable(props) {
    const {nodes,handleOpen} = props;
    const currentrow = {
        academicProgram: nodes.Name,
        department: "",
        endDate: nodes.EndDate,
        fees: nodes.Fees,
        institute: "",
        instituteId: nodes.ParentID,
        programId: nodes.Id,
        startDate:nodes.StartDate,
        RecordType:nodes.RecordType,
        AcademicYear:nodes.AcademicYear
    };
    const startDate = moment(nodes.StartDate);
    const endDate = moment(nodes.EndDate);
  
    const classes = useStyles();
    
    const rows = [
        createData(nodes.Name,nodes.StartDate,nodes.EndDate,nodes.Fees),
    ];
    // console.log("dates",today,startDate,endDate);
    // if (today<startDate) {
    //   console.log("upcoming");
    // } else if(startDate <= today <= endDate) {
    //   console.log("present");
    // }else{
    //   console.log("closed");
    // }

  return (
    <TableContainer component={Paper} elevation={0} className={classes.item}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell style={{color:"#505F79"}}>Academic Program</TableCell>
            <TableCell align="left" style={{color:"#505F79"}}>Start Date</TableCell>
            <TableCell align="left" style={{color:"#505F79"}}>End Date</TableCell>
            <TableCell align="left" style={{color:"#505F79"}}> Application Fee</TableCell>
            <TableCell align="left" style={{color:"#505F79"}}>Apply</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
              <span style={{color:"#0c4ea2",fontSize:14}}>{row.name}</span>
              </TableCell>
              <TableCell align="left"><span style={{fontSize:14}}>{row.calories}</span></TableCell>
              <TableCell align="left"><span style={{fontSize:14}}>{row.fat}</span></TableCell>
              <TableCell align="left"><span style={{fontSize:14}}>{row.carbs}</span></TableCell>
              <TableCell align="left">
                {
                  today < startDate ? <KenButton label="Notify Me" variant="outlined" color="primary" onClick={(e)=>{handleOpen(currentrow)}}/>
                  : startDate <= today && today <= endDate  ? <KenButton label="Apply Now" variant="outlined" color="primary" onClick={(e)=>{handleOpen(currentrow)}}/>
                  :<KenButton label="Closed" variant="outlined" color="primary" disabled/>
                }
      
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
